function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "money");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Paid-Profile",
  transform: "translate(-355.000000, -203.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(164.000000, 182.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(161.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "money",
  transform: "translate(29.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bound",
  x: 1,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M3,6 L22,6 C22.5522847,6 23,6.44771525 23,7 L23,17 C23,17.5522847 22.5522847,18 22,18 L3,18 C2.44771525,18 2,17.5522847 2,17 L2,7 C2,6.44771525 2.44771525,6 3,6 Z M12.5,16 C14.709139,16 16.5,14.209139 16.5,12 C16.5,9.790861 14.709139,8 12.5,8 C10.290861,8 8.5,9.790861 8.5,12 C8.5,14.209139 10.290861,16 12.5,16 Z",
  id: "Combined-Shape-Copy",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0.3,
  transform: "translate(12.500000, 12.000000) rotate(15.000000) translate(-12.500000, -12.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M3,6 L22,6 C22.5522847,6 23,6.44771525 23,7 L23,17 C23,17.5522847 22.5522847,18 22,18 L3,18 C2.44771525,18 2,17.5522847 2,17 L2,7 C2,6.44771525 2.44771525,6 3,6 Z M12.5,16 C14.709139,16 16.5,14.209139 16.5,12 C16.5,9.790861 14.709139,8 12.5,8 C10.290861,8 8.5,9.790861 8.5,12 C8.5,14.209139 10.290861,16 12.5,16 Z M12.5,14 C13.6045695,14 14.5,13.1045695 14.5,12 C14.5,10.8954305 13.6045695,10 12.5,10 C11.3954305,10 10.5,10.8954305 10.5,12 C10.5,13.1045695 11.3954305,14 12.5,14 Z",
  id: "Combined-Shape",
  fill: "#EB6324",
  fillRule: "nonzero"
}))))));

var SvgPaidProfileSubscriptionActive = function SvgPaidProfileSubscriptionActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "18px",
    viewBox: "0 0 23 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaidProfileSubscriptionActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paid-profile-subscription-active.2146dea5.svg";
export { ForwardRef as ReactComponent };